import "./DustControl.module.css";
import Header from "@/reusable_sections/Header";
import DustControlHero from "./sections/DustControlHero";
import DustFaq from "./sections/DustFaq";
import DustControl from "./sections/DustControl";
import TechnicalBenefits from "./sections/TechnicalBenefits";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function DustControlPage() {
  return <div>
      <Header />
      
      <DustControlHero />
      <DustFaq />
      <DustControl />
      <TechnicalBenefits />
      <CallToAction />
      <Footer />
    </div>;
}